import { Tabs } from '@fullscreendigital/carrefour-dex-fe'
import s from '../../../commonStyles.modules.scss'
import { useState } from 'react'
import CentralizeStores from './CentralizeStores/CentralizeStoresUpgrade'
import CentralizeHubs from './CentralizeHubs/CentralizeHubs'
import { useNotification } from 'hooks'
import { getScreenPermissions } from '../../api'
import { SCREENS } from '../../constants'

const CentralizeStoresHub = () => {
  const [currentTab, setCurrentTab] = useState<number>(0)

  const { showNotification } = useNotification()

  const { data: permissions } = getScreenPermissions(
    showNotification,
    SCREENS.ADMIN_DELIVERY_MATRIX
  )

  return (
    <div className={s.mainContainer}>
      <Tabs
        containerStyle={{}}
        tabContentBoxStyle={{
          padding: 0
        }}
        tabs={[
          {
            content: <CentralizeStores permissions={permissions} />,
            label: 'Magazine',
            tabIndex: 0
          },
          {
            content: <CentralizeHubs permissions={permissions} />,
            label: 'Huburi',
            tabIndex: 1
          }
        ]}
        tabsAriaLabel="Centralizare magazine şi huburi"
        tabsContainerStyle={{
          borderBottom: 1,
          marginBottom: '24px',
          borderColor: '#223fa0',
          '.MuiTabs-flexContainer': {
            '.MuiButtonBase-root': {
              maxWidth: 'fit-content'
            }
          }
        }}
        value={currentTab}
        onChange={(_, value) => setCurrentTab(value)}
      />
    </div>
  )
}

export default CentralizeStoresHub
